/**
 * Hidden/Programmatic Filter Definitions
 * * These filters are not shown in the UI but are used programmatically
 * by map flyout components to add filters when users interact with map points.
 * * These filters are "hidden" because they're applied automatically based on
 * user interactions (e.g., clicking a map point and adding it to filters).
 */

export const hiddenFilters = {
    COMPANY: {
        COMPANY_ID: {
            id: 'COMPANY_ID',
            display: 'Company ID',
            schemaProperty: 'company_id',
            operatorDisplay: 'in',
            operatorId: 'equals',
            component: 'combobox',
            multiple: true,
            fieldDisplay: '[company_id]',
            hide: true
        },
        COMPANY_IDENTITY: {
            id: 'COMPANY_IDENTITY',
            display: 'Company Identity',
            schemaProperty: 'company_identity',
            operatorDisplay: 'in',
            operatorId: 'equals',
            component: 'combobox',
            multiple: true,
            fieldDisplay: '[company_identity]',
            hide: true
        },
        COMPANY_ADDRESS_CITY_REGION_FORMATTED: {
            id: 'COMPANY_ADDRESS_CITY_REGION_FORMATTED',
            display: 'City, Region',
            schemaProperty: 'company_address_city_region_formatted',
            operatorDisplay: 'in',
            operatorId: 'equals',
            component: 'combobox',
            multiple: true,
            fieldDisplay: '[company_address_city_region_formatted]',
            hide: true
        },
        COMPANY_ADDRESS_GEO_RADIUS: {
            id: 'COMPANY_ADDRESS_GEO_RADIUS',
            display: 'Geo Radius',
            schemaProperty: 'company_address_geo_radius',
            operatorDisplay: 'within radius',
            operatorId: 'geoRadius',
            component: 'geoRadius',
            fieldDisplay: '[company_address_geo_radius]',
            hide: true
        }
    }
};

export default hiddenFilters;
